import type { InstitutionStatisticsPlugin } from '@adornis/buchungsheld-db/db-plugins.js';
import type { BHFilter } from '@adornis/buchungsheld-db/entities/bh-filter.js';
import { html } from 'lit';
import { from } from 'rxjs';
import { startWith, switchMap } from 'rxjs/operators';

export const fromPromiseStartWithNull = () => switchMap((p: Promise<any>) => from(p).pipe(startWith(null)));

export const defaultInstitutionStatisticsPlugin: InstitutionStatisticsPlugin = {
  id: 'institution-statistics::default',
  type: 'institution-statistics',
  render: (filter: BHFilter) => {
    return html`<default-institution-statistics .filter=${filter}></default-institution-statistics>`;
  },
};
